import React from "react";
import Context from "../../../../context";
import {
  CustomView,
  CustomModal,
  CustomButton2,
  UserInformation,
} from "../../../../components";

import "./index.sass";
import { useTranslation } from "react-i18next";

const Approve = () => {
  const {
    showModal,
    setShowModal,
    isLoading,
    selectedDriver,
    approveFunction,
  } = React.useContext(Context.DriverScreen);

  // ?? ===========================================================================================================
  // ??                                              JSX Content
  // ?? -----------------------------------------------------------------------------------------------------------

  const { t } = useTranslation();

  return (
    <section id="driver-approve-modal-container">
      <CustomModal
        onClose={() => setShowModal!("NONE")}
        open={showModal === "APPROVE"}
        label="تایید راننده"
      >
        <CustomView.Container className="approve-form-content">
          <CustomView.Row className="user-information-container">
            <CustomView.Column>
              <UserInformation
                name={selectedDriver?.firstName}
                avatar={selectedDriver?.avatar}
                isBlock={
                  !selectedDriver?.driverInformation?.approved?.isApproved
                }
                lastName={selectedDriver?.lastName}
                phoneNumber={selectedDriver?.phoneNumber}
              />
            </CustomView.Column>
          </CustomView.Row>
          <CustomView.Row className="form-row">
            <CustomView.Column
              large={3}
              medium={4}
              small={6}
              className="form-colum"
            >
              <CustomButton2
                isLoading={isLoading}
                onClick={() => setShowModal!("NONE")}
                title="لغو"
                type="danger"
              />
            </CustomView.Column>
            <CustomView.Column
              large={3}
              medium={4}
              small={6}
              className="form-colum"
            >
              <CustomButton2
                isLoading={isLoading}
                onClick={() => approveFunction!(selectedDriver?._id)}
                title={t("approve")}
              />
            </CustomView.Column>
          </CustomView.Row>
        </CustomView.Container>
      </CustomModal>
    </section>
  );
};

export default Approve;
